/**
 * Created by razial on 21.09.2026.
 */

cleverapps.overrideStyles(cleverapps.styles.LanternView, {
    offset: {
        x: 0,
        y: 0
    }
});

cleverapps.overrideStyles(cleverapps.styles.LanternWindow, {
    margin: 20,
    window: {
        padding: {
            top: 35,
            bottom: 35,
            x: 20
        }
    },
    timer: {
        y: { align: "top", dy: -5 }
    },
    bonuses: {
        margin: 3,
        x: { align: "center" },
        y: {
            align: "bottom",
            dy: 30
        },
        bonusBg: {
            width: 168,
            height: 168
        },
        amount: {
            x: {
                align: "right",
                dx: -7
            },
            y: {
                align: "bottom",
                dy: 7
            },

            bg: {
                x: { align: "center" },
                y: {
                    align: "center",
                    dy: -5
                },
                width: 86,
                height: 86
            }
        }
    },
    text: {
        width: 620,
        height: 130
    },
    animation: {
        y: 12
    }
});
